import React, { Component } from 'react';
import CouncilJobView from './CouncilJobView'
import { url } from '../../../Server/url/GlobalUrl'
import moment from 'moment'


class CouncilJobComponent extends Component {
    state = {
        job_detail: [],
        application_detail: [],
        modal_show: false,
        authResponse: '',
        contract_type_arr: { 1: 'Emergency', 2: 'Temporary', 3: 'Permanent' },
        carer_type_arr: { 1: 'Nurses', 2: 'Carers',3:'Nurses & Carers'  },
        modal_table_show: false,
        shift_detail: [],
        shift_modal_show: false,
    }
    componentDidMount() {
        var token = localStorage.getItem("token")
        fetch((url + "/jobs/admin-jobs/?job_type=Council&status=Pending"), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.length > 0) {
                        console.log('jobs____pendind____result', result)
                        this.setState({
                            job_detail: result
                        })
                    }
                    fetch((url + "/jobs/admin-jobs/?job_type=Council&status=Booking"), {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        },
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                console.log('jobs____Booking____result', result)
                                if (result.length > 0) {
                                    var i;
                                    for (i of result) {
                                        this.state.job_detail.push(i)

                                    }
                                    this.setState({
                                        job_detail: this.state.job_detail
                                    })
                                    var i;
                                    for (i = 0; i < this.state.job_detail.length; i++) {

                                        this.state.job_detail[i]['shift_count'] = this.state.job_detail[i].shifts.length
                                    }
                                    console.log('job_detail', this.state.job_detail)
                                    this.setState({ job_detail: this.state.job_detail })
                                }
                            })
                })


    }
    hideShiftModal = () => {
        this.setState({ shift_modal_show: false })
    }

    showShiftModal = () => {
        this.setState({ shift_modal_show: true })
    }
    hideCustomModal = () => {
        this.setState({ modal_show: false })
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })
    }

    hideTableModal = () => {
        this.setState({ modal_table_show: false })
    }

    showTableModal = () => {
        this.setState({ modal_table_show: true })
    }

    handleShift = (data) => {
        console.log(data);
        this.setState({ shifts: data })
    }

    handleShiftCloseModal = () => {
        this.setState({ showShiftModal: false });
    }

    handleShiftShowModal = () => {
        this.setState({ showShiftModal: true });
    }

    handledelete = (id) => {
        console.log('hello all deleted', id)
        var token = localStorage.getItem("token")
        fetch((url + "/jobs/job-post/" + id + '/'), {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        })
            .then((response) => {
                console.log("response", response)
                if (response['status'] === 201 || response['status'] === 200 || response['status'] === 204) {
                    this.showCustomModal()
                    this.setState({ authResponse: 'Deleted Successfully' })
                    fetch((url + "/jobs/admin-jobs/?job_type=Council&status=Pending"), {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        },
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                if (result.length > 0) {
                                    console.log('result', result)
                                    this.setState({
                                        job_detail: result
                                    })
                                }
                                fetch((url + "/jobs/admin-jobs/?job_type=Council&status=Booking"), {
                                    method: 'GET',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + token,
                                    },
                                })
                                    .then(res => res.json())
                                    .then(
                                        (result) => {
                                            console.log('result', result)
                                            if (result.length > 0) {
                                                var i;
                                                for (i of result) {
                                                    this.state.job_detail.push(i)

                                                }
                                                this.setState({
                                                    job_detail: this.state.job_detail
                                                })

                                            } else {
                                                this.setState({
                                                    job_detail: []
                                                })
                                            }
                                        })
                            })
                } else if (response['status'] === 400) {
                    this.showCustomModal()
                    this.setState({ authResponse: 'Something went wrong please try again' })
                }
            })
    }
    handlepreview = (id) => {
        console.log('id', id)
        let url = '/job-details/' + id
        window.location.replace(url)
    }

    handleshift = (id) => {
        console.log('id', id)
        this.setState({ 'shift_modal_show': true })
        var token = localStorage.getItem("token")
        fetch((url + "/jobs/admin-jobs/" + id + '/'), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log('result', result)
                    this.setState({
                        shift_detail: result.shifts
                    })


                })
        console.log('result.shifts', this.state.shift_detail)

    }

    handleapplicant = (id) => {
        console.log('id', id)

        let auth = localStorage.getItem("token")
        fetch((url + "/jobs/admin-jobs/" + id + '/'), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + auth,
            },
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("result", result);
                    console.log('applicant__________result', result)
                    if (result) {

                        //  var i;
                        //     for (i of result) {
                        //         var day = moment(result.date_applied).format("MMMM DD, YYYY")
                        //         i['date_applied'] = day
                        //         console.log('day',day)

                        //     }
                        console.log('check status', result)
                        this.setState({
                            application_detail: result
                        })
                    }

                })


        fetch((url + "/api/v1/user/admin-jobs-applied-users/?job_id=" + id), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + auth,
            },
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log('candidate__________details', result)

                    if (result.length > 0) {
                        this.setState({
                            application_detail: { ...this.state.application_detail, ["eligible_candidates"]: result }
                        })
                        this.showTableModal()
                    } else {
                        this.showCustomModal()
                        this.setState({ authResponse: 'No One has applied for this job' })
                    }
                    console.log("++++", this.state.application_detail)
                })


    }


    render() {
        return (
            <CouncilJobView
                job_detail={this.state.job_detail}
                handledelete={this.handledelete}
                authResponse={this.state.authResponse}
                modal_show={this.state.modal_show}
                hideCustomModal={this.hideCustomModal}
                handlepreview={this.handlepreview}
                handleapplicant={this.handleapplicant}
                hideTableModal={this.hideTableModal}
                handleShift={this.handleShift}
                handleShiftShowModal={this.handleShiftShowModal}
                handleShiftCloseModal={this.handleShiftCloseModal}
                showShiftModal={this.state.showShiftModal}
                shifts={this.state.shifts}
                contract_type_arr={this.state.contract_type_arr}
                carer_type_arr={this.state.carer_type_arr}
                modal_table_show={this.state.modal_table_show}
                application_detail={this.state.application_detail}
                hideShiftModal={this.hideShiftModal}
                // showShiftModal={this.showShiftModal}
                shift_modal_show={this.state.shift_modal_show}
                handleshift={this.handleshift}
                shift_detail={this.state.shift_detail}
            />
        )
    }

}

export default CouncilJobComponent;
